import i18next from 'i18next'

import { ValidateFormService } from 'services/ValidateFormService'
import { validatePickPointFiles } from 'sections/LKSection/shared/PickPointSharedModule/components/PickPointFilesForm/validate'
import { Country } from 'shared/types/types'

import { OrderKeys } from '../../../data'
import { ActivateOrderUiStore } from '../../../stores/ActivateOrder/ActivateOrderUiStore'

export class ValidateOrderActivate extends ValidateFormService {
  validate = (uiStore: ActivateOrderUiStore, companyCountry: Country) => {
    const errors: string[] = []

    const getKey = (key: string) => `${OrderKeys.activateOrderPage}.validate.${key}`

    if (companyCountry === Country.BY) {
      if (uiStore.ownerGln.trim().length === 0) {
        errors.push(i18next.t(getKey('invalidOwnerGln')))
      }
      if (uiStore.glnPvz.trim().length === 0) {
        errors.push(i18next.t(getKey('invalidGlnPvz')))
      }
      if (uiStore.molName.trim().length === 0) {
        errors.push(i18next.t(getKey('invalidMolName')))
      }
    }

    if (uiStore.signboardSizeItem === null) {
      errors.push(i18next.t(getKey('invalidSignboardSize')))
    }
    if (uiStore.signboardFormatItem === null) {
      errors.push(i18next.t(getKey('invalidSignboardFormat')))
    }

    errors.push(...(validatePickPointFiles.validate(uiStore.fileList, 'array', 'activate') as string[]))

    return this.hasNotErrors(errors, i18next.t(getKey('pvzActivationError')))
  }
}

export const validateOrderActivate = new ValidateOrderActivate()
